import React, { useState, useEffect } from "react";
import axios from "axios";
import moment from "moment";
import NoData from "../components/NoData.js";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import DemeritList from "../components/info/DemeritList";
import BlackList from "../components/info/BlackList";
import { AlertSwal, DangerSwal } from "../components/CustomSwal";
import { FormattedMessage, useIntl } from "react-intl";

function Info(props) {
  const [data, setData] = useState(null);
  const [chgUserData, setChgUserData] = useState(null);
  const [chgUserShow, setChgUserShow] = useState(false);
  const sid = sessionStorage.getItem("sid");
  const authid = sessionStorage.getItem("authid");
  const config = props.config;
  const intl = useIntl();

  const GetBookInfo = () => {
    props.setLoading(true);
    axios
      .get(config.API_URL + `/GetBookInfo.aspx`, {
        params: {
          sid: sid,
          authid: authid,
          restype: "json",
        },
      })
      .then((res) => {
        const data = res.data[0];
        if (data.rescode === "3" || data.rescode === "4") {
          props.setSession(false);
        } else {
          if (data.rescode === "1") {
            if (data.resdata) {
              setData(data.resdata);
            } else {
              setData([]);
            }
          } else {
            AlertSwal.fire({
              title: intl.formatMessage({ id: "global.alert_title" }),
              text: intl.formatMessage({ id: "global.failure" }),
              confirmButtonText: intl.formatMessage({ id: "global.confirm" }),
            });
          }
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        props.setLoading(false);
      });
  };

  const BookDel = (info) => {
    DangerSwal.fire({
      title:
        intl.formatMessage({ id: "info.confirm_delete_reservation" }) + "？",
      html: (
        <div className="text-left">
          <span>
            {intl.formatMessage({ id: "global.reader" })} :{" "}
            <span className="d-inline-block">{info.username}</span>
          </span>
          <br />
          <span>
            {intl.formatMessage({ id: "global._spacetype" })} :{" "}
            <span className="d-inline-block">
              {intl.formatMessage({
                id: `global.spacetype.${info.spacetype}`,
                defaultMessage: info.spacetypename,
              })}
            </span>
          </span>
          <br />
          <span>
            {intl.formatMessage({ id: "global.zonename" })} :{" "}
            <span className="d-inline-block">
              {intl.formatMessage({
                id: `global.zoneid.${info.zoneid}`,
                defaultMessage:
                  info.zonename === "" ? info.spacetypename : info.zonename,
              })}
            </span>
          </span>
          <br />
          <span>
            {intl.formatMessage({ id: "global.devicename" })} :{" "}
            <span className="d-inline-block">{info.devname}</span>
          </span>
          <br />
          <span>
            {intl.formatMessage({ id: "global.reservation_time" })} :{" "}
            <span className="d-inline-block">{info.bookedatetime}</span>
          </span>
        </div>
      ),
      showCancelButton: true,
      confirmButtonText: intl.formatMessage({
        id: "info.confirm_delete_button",
      }),
      cancelButtonText: intl.formatMessage({ id: "global.cancel" }),
    }).then((result) => {
      if (result.value) {
        props.setLoading(true);
        axios
          .get(config.API_URL + `/BookDel.aspx`, {
            params: {
              sid: sid,
              authid: authid,
              bookid: info.bookid,
              restype: "json",
            },
          })
          .then((res) => {
            const data = res.data[0];
            if (data.rescode === "3" || data.rescode === "4") {
              props.setSession(false);
            } else {
              if (data.rescode === "1") {
                AlertSwal.fire({
                  title: intl.formatMessage({ id: "global.alert_title" }),
                  text: intl.formatMessage({ id: "global.success" }),
                  confirmButtonText: intl.formatMessage({
                    id: "global.confirm",
                  }),
                });
                GetBookInfo();
              } else {
                AlertSwal.fire({
                  title: intl.formatMessage({ id: "global.alert_title" }),
                  text: intl.formatMessage({ id: "global.failure" }),
                  confirmButtonText: intl.formatMessage({
                    id: "global.confirm",
                  }),
                });
              }
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            props.setLoading(false);
          });
      }
    });
  };

  const BookSignout = (info) => {
    DangerSwal.fire({
      title: intl.formatMessage({ id: "info.confirm_timeout_leave" }) + "？",
      html: (
        <div className="text-left">
          <span>
            {intl.formatMessage({ id: "global.reader" })} :{" "}
            <span className="d-inline-block">{info.username}</span>
          </span>
          <br />
          <span>
            {intl.formatMessage({ id: "global._spacetype" })} :{" "}
            <span className="d-inline-block">
              {intl.formatMessage({
                id: `global.spacetype.${info.spacetype}`,
                defaultMessage: info.spacetypename,
              })}
            </span>
          </span>
          <br />
          <span>
            {intl.formatMessage({ id: "global.zonename" })} :{" "}
            <span className="d-inline-block">
              {intl.formatMessage({
                id: `global.zoneid.${info.zoneid}`,
                defaultMessage:
                  info.zonename === "" ? info.spacetypename : info.zonename,
              })}
            </span>
          </span>
          <br />
          <span>
            {intl.formatMessage({ id: "global.devicename" })} :{" "}
            <span className="d-inline-block">{info.devname}</span>
          </span>
          <br />
          <span>
            {intl.formatMessage({ id: "global.reservation_time" })} :{" "}
            <span className="d-inline-block">{info.bookedatetime}</span>
          </span>
        </div>
      ),
      showCancelButton: true,
      confirmButtonText: intl.formatMessage({
        id: "info.confirm_leave_button",
      }),
      cancelButtonText: intl.formatMessage({ id: "global.cancel" }),
    }).then((result) => {
      if (result.value) {
        props.setLoading(true);
        axios
          .get(config.API_URL + `/BookSignout.aspx`, {
            params: {
              sid: sid,
              authid: authid,
              bookid: info.bookid,
              restype: "json",
            },
          })
          .then((res) => {
            const data = res.data[0];
            if (data.rescode === "3" || data.rescode === "4") {
              props.setSession(false);
            } else {
              if (data.rescode === "1") {
                AlertSwal.fire({
                  title: intl.formatMessage({ id: "global.alert_title" }),
                  text: intl.formatMessage({ id: "global.success" }),
                  confirmButtonText: intl.formatMessage({
                    id: "global.confirm",
                  }),
                });
                GetBookInfo();
              } else {
                AlertSwal.fire({
                  title: intl.formatMessage({ id: "global.alert_title" }),
                  text: intl.formatMessage({ id: "global.failure" }),
                  confirmButtonText: intl.formatMessage({
                    id: "global.confirm",
                  }),
                });
              }
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            props.setLoading(false);
          });
      }
    });
  };

  const BookUserVerify = () => {
    let findDuplicates = (arr) =>
      arr.filter((item, index) => arr.indexOf(item) !== index);
    let valid = true;
    let invalidMsg = "";
    let params = {};
    let useridparam = "";
    let userids = [];
    let chguserid = document
      .getElementById("useridToChange")
      .value.toUpperCase();
    document.getElementsByName("userid").forEach((elem) => {
      userids.push(elem.value.toUpperCase());
    });
    if (findDuplicates(userids).length > 0) {
      valid = false;
      invalidMsg = intl.formatMessage({
        id: "appointment.alert.reader_id_repeat",
      });
    }
    for (let i = 0; i < userids.length; i++) {
      if (userids[i] !== "" && userids[i] !== undefined) {
        if (userids[i] === sessionStorage.getItem("userid")) {
          valid = false;
          invalidMsg = intl.formatMessage({
            id: "appointment.alert.reader_id_self",
          });
        } else {
          useridparam += "," + userids[i];
        }
      } else {
        valid = false;
        invalidMsg = intl.formatMessage({
          id: "appointment.alert.reader_id_empty",
        });
      }
    }
    if (useridparam) useridparam = useridparam.substring(1);
    params = {
      sid: sid,
      authid: authid,
      spacetype: chgUserData.spacetype,
      userid: chguserid,
      restype: "json",
    };
    if (valid) {
      props.setLoading(true);
      axios
        .get(config.API_URL + `/BookUserVerify.aspx`, {
          params: params,
        })
        .then((res) => {
          const data = res.data[0];
          if (data.rescode === "3" || data.rescode === "4") {
            props.setSession(false);
          } else {
            if (data.rescode === "1") {
              BookChangeUser(chguserid);
            } else {
              AlertSwal.fire({
                title: intl.formatMessage({ id: "global.alert_title" }),
                text: intl.formatMessage({ id: "global.failure" }),
                confirmButtonText: intl.formatMessage({ id: "global.confirm" }),
              });
            }
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          props.setLoading(false);
        });
    } else {
      AlertSwal.fire({
        title: invalidMsg,
      });
    }
  };

  const BookChangeUser = (chguserid) => {
    props.setLoading(true);
    axios
      .get(config.API_URL + `/BookChangeUser.aspx`, {
        params: {
          sid: sid,
          authid: authid,
          bookid: chgUserData.bookid,
          chguserid: chguserid,
          restype: "json",
        },
      })
      .then((res) => {
        const data = res.data[0];
        if (data.rescode === "3" || data.rescode === "4") {
          props.setSession(false);
        } else {
          if (data.rescode === "1") {
            AlertSwal.fire({
              title: intl.formatMessage({ id: "global.alert_title" }),
              text: intl.formatMessage({ id: "global.success" }),
              confirmButtonText: intl.formatMessage({ id: "global.confirm" }),
            });
            setChgUserShow(false);
            GetBookInfo();
          } else {
            AlertSwal.fire({
              title: intl.formatMessage({ id: "global.alert_title" }),
              text: intl.formatMessage({ id: "global.failure" }),
              confirmButtonText: intl.formatMessage({ id: "global.confirm" }),
            });
          }
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        props.setLoading(false);
      });
  };

  useEffect(GetBookInfo, []);

  if (data === null) {
    return "";
  }

  return (
    <>
      <div className="ticketWrap row">
        {data.length === 0 ? <NoData /> : null}
        {data.map((row, index) => {
          let statusBtn = null;
          let canChangeUser = config.SPACETYPE[`st_${row.spacetype}`][1];
          let usersCount = row.userid.split("|").length;
          let endTime = null;
          if (row.bookedatetime.indexOf(" ") !== -1) {
            // 有空格就是 type = time
            endTime =
              row.bookedatetime.split(" ")[0] +
              " " +
              row.bookedatetime.split("~")[1];
            endTime = moment(endTime, "YYYYMMDD HH:mm:ss");
          } else {
            // 否則是 date
            endTime = moment(row.bookedatetime.split("~")[1], "YYYYMMDD");
          }
          const currentTime = row.currdatetime
            ? moment(row.currdatetime, "YYYYMMDD HH:mm:ss")
            : moment();

          if (
            row.usestatus === "-2" ||
            row.usestatus === "-1" ||
            row.usestatus === "0" ||
            row.usestatus === "1"
          ) {
            statusBtn = (
              <>
                {(row.usestatus === "0" || row.usestatus === "1") &&
                canChangeUser &&
                usersCount > 1 ? (
                  <span
                    className="status_btn status_btn_change"
                    onClick={() => {
                      setChgUserData({
                        bookid: row.bookid,
                        spacetype: row.spacetype,
                        userids: row.userid.toUpperCase().split("|"),
                      });
                      setChgUserShow(true);
                    }}
                  >
                    <FormattedMessage id="info.change_user" />
                  </span>
                ) : null}
                {/* 2022-11-17 若預約時間為今天，不可進行預約刪除 */}
                {!endTime.isSame(currentTime, "day") && (
                  <span
                    className="status_btn status_btn_del"
                    onClick={() => {
                      BookDel(row);
                    }}
                  >
                    <FormattedMessage id="info.delete_reservation" />
                  </span>
                )}
              </>
            );
          } else if (
            row.usestatus === "2" &&
            config.BOOK_END_EARLIER &&
            !endTime.isBefore(currentTime)
          ) {
            statusBtn = (
              <span
                className="status_btn status_btn_del"
                onClick={() => {
                  BookSignout(row);
                }}
              >
                <FormattedMessage id="info.timeout_leave" />
              </span>
            );
          }
          return (
            <div className="col-12 col-md-6" key={row.bookid}>
              <div className={`ticket t_status_${row.usestatus} d-flex`}>
                <div className="w-50 ticket_l">
                  <span>{row.devname}</span>
                  <span>
                    <FormattedMessage
                      defaultMessage={row.spacetypename}
                      id={`global.spacetype.${row.spacetype}`}
                    />
                  </span>
                  <span className="status">
                    【
                    <FormattedMessage id={`info.usestatus.${row.usestatus}`} />
                    】
                  </span>
                  {statusBtn}
                </div>
                <div className="ticket_line"></div>
                <div className="w-75 ticket_r">
                  {config.FLOORMAP_URL ? (
                    <span>
                      <a
                        href={config.FLOORMAP_URL + row.locationid + ".aspx"}
                        target="FloorMapWindow"
                      >
                        <FormattedMessage
                          defaultMessage={
                            row.zonename === ""
                              ? row.spacetypename
                              : row.zonename
                          }
                          id={`global.zoneid.${row.zoneid}`}
                        />
                      </a>
                    </span>
                  ) : (
                    <span>
                      <FormattedMessage
                        defaultMessage={
                          row.zonename === "" ? row.spacetypename : row.zonename
                        }
                        id={`global.zoneid.${row.zoneid}`}
                      />
                    </span>
                  )}
                  <span>{row.username}</span>
                  <span>{row.bookedatetime}</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <hr />
      <div className="demeritWrap row">
        <Col sm={12} md={6}>
          <DemeritList
            config={config}
            setLoading={props.setLoading}
            setSession={props.setSession}
          />
        </Col>
        <Col sm={12} md={6}>
          <BlackList
            config={config}
            setLoading={props.setLoading}
            setSession={props.setSession}
          />
        </Col>
      </div>
      <Modal
        size="lg"
        show={chgUserShow}
        onHide={() => {
          setChgUserShow(false);
        }}
        centered
      >
        <Modal.Header className="bg_brand" closeButton>
          <Modal.Title>
            <span>
              <FormattedMessage id="info.change_user" />
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Row>
              {chgUserData
                ? chgUserData.userids.map((row, index) => {
                    return (
                      <Form.Group as={Col} sm={12} md={6} key={index}>
                        <Form.Label>
                          <FormattedMessage id="global.reader_id" />
                        </Form.Label>
                        <Form.Control
                          defaultValue={row}
                          disabled={row !== sessionStorage.getItem("userid")}
                          name="userid"
                          id={
                            row === sessionStorage.getItem("userid")
                              ? "useridToChange"
                              : null
                          }
                        />
                      </Form.Group>
                    );
                  })
                : null}
            </Form.Row>
          </Form>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-between">
          <Button variant="light" onClick={() => setChgUserShow(false)}>
            <FormattedMessage id="global.cancel" />
          </Button>
          <Button
            className="bg_brand"
            variant="primary"
            onClick={() => BookUserVerify()}
          >
            <FormattedMessage id="info.confirm_change_user" />
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default Info;
